export const social = {
    facebook: function(urlToShare) {
        return `https://facebook.com/sharer/sharer.php?u=${urlToShare}`
    },

    twitter: function(urlToShare) {
        return `https://twitter.com/intent/tweet/?url=${urlToShare}`
    },

    linkedin: function(urlToShare) {
        return `https://www.linkedin.com/shareArticle?mini=true&url=${urlToShare}&source=${urlToShare}`
    }
}
